var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    height: "1024px",
    width: "1024px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u6682\u65E0\u6570\u636E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-1",
    y2: "100%",
    x2: "50%",
    y1: "0%",
    x1: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F9AB21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FEE127"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-2",
    y2: "50%",
    x2: "57.3278292%",
    y1: "-144.281325%",
    x1: "48.3426312%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FEE127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0,
    stopColor: "#F9AB21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-3",
    y2: "100%",
    x2: "50%",
    y1: "0%",
    x1: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F9AB21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0,
    stopColor: "#FFF29D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-4",
    y2: "100%",
    x2: "50%",
    y1: "0%",
    x1: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F9AB21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0,
    stopColor: "#FFF29D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-5",
    y2: "110.706017%",
    x2: "0%",
    y1: "30.0140424%",
    x1: "89.4431057%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F9AB21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0,
    stopColor: "#FEE127"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-6",
    y2: "100%",
    x2: "50%",
    y1: "0%",
    x1: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF29D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F9AB21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-7",
    y2: "66.3046487%",
    x2: "0%",
    y1: "44.6320969%",
    x1: "89.4431057%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F9AB21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0,
    stopColor: "#FEE127"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-8",
    y2: "55.4410251%",
    x2: "0%",
    y1: "48.2086768%",
    x1: "89.4431057%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F9AB21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0,
    stopColor: "#FEE127"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-9",
    y2: "48.5513062%",
    x2: "80.3094872%",
    y1: "49.6884536%",
    x1: "17.8861305%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF29D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F9AB21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-10",
    y2: "67.4747805%",
    x2: "62.2332291%",
    y1: "-15.7088481%",
    x1: "23.6849724%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF29D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F9AB21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-11",
    y2: "59.8334296%",
    x2: "80.4805179%",
    y1: "40.8578254%",
    x1: "30.3120202%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF29D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F9AB21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-12",
    y2: "50.3711512%",
    x2: "70.7153436%",
    y1: "50%",
    x1: "8.96877742%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF29D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F9AB21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-13",
    y2: "100%",
    x2: "50%",
    y1: "0%",
    x1: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF29D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F9AB21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-14",
    y2: "48.9376799%",
    x2: "121.25318%",
    y1: "50%",
    x1: "2.77296379%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF29D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F9AB21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-15",
    y2: "50%",
    x2: "118.501965%",
    y1: "48.7841362%",
    x1: "-2.25347937%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF29D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F9AB21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-16",
    y2: "73.6326896%",
    x2: "100%",
    y1: "11.7098971%",
    x1: "14.3474826%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFD4FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5792F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-17",
    y2: "93.1271749%",
    x2: "50%",
    y1: "-31.010887%",
    x1: "43.707299%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFD4FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5792F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-18",
    y2: "100%",
    x2: "50%",
    y1: "12.9243097%",
    x1: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFCDA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFE8D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-19",
    y2: "100%",
    x2: "93.4428548%",
    y1: "0%",
    x1: "41.3771295%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FEE0BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-20",
    y2: "61.3220709%",
    x2: "210.359568%",
    y1: "25.7376426%",
    x1: "35.6067948%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FEE127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F9AB21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-21",
    y2: "100%",
    x2: "50%",
    y1: "0%",
    x1: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FEE127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F9AB21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-22",
    y2: "38.1816114%",
    x2: "126.959811%",
    y1: "25.7376426%",
    x1: "33.2709467%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FEE127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F9AB21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-23",
    y2: "100%",
    x2: "50%",
    y1: "0%",
    x1: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF29D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F9AB21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-24",
    y2: "100%",
    x2: "50%",
    y1: "0%",
    x1: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF29D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F9AB21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-25",
    y2: "100%",
    x2: "50%",
    y1: "0%",
    x1: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF29D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F9AB21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-26",
    y2: "100%",
    x2: "50%",
    y1: "0%",
    x1: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF29D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F9AB21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-27",
    y2: "100%",
    x2: "50%",
    y1: "0%",
    x1: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF29D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F9AB21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-28",
    y2: "100%",
    x2: "50%",
    y1: "0%",
    x1: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF29D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F9AB21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-29",
    y2: "100%",
    x2: "50%",
    y1: "0%",
    x1: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF29D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F9AB21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-30",
    y2: "100%",
    x2: "50%",
    y1: "0%",
    x1: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F9AB21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FEE127"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    fill: "none",
    strokeWidth: 1,
    stroke: "none",
    id: "\\u6682\\u65E0\\u6570\\u636E"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 1024,
    width: 1024,
    y: 0,
    x: 0,
    id: "\\u77E9\\u5F62"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.000000, 184.000000)",
    id: "\\u7F16\\u7EC4"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.100000001,
    fill: "url(#linearGradient-1)",
    id: "\\u8DEF\\u5F84-58",
    d: "M14.348443,454.673746 C6.90795489,422.581231 -41.5254481,213.587126 95.4161533,184.85131 C232.357755,156.115494 313.258228,189.584206 373.428763,131.071089 C433.599298,72.5579715 448.604794,82.1616636 498.026862,86.0316824 C547.448931,89.9017013 604.728401,47.6647155 623.975638,34.9776724 C643.222875,22.2906294 817.002695,-59.3369678 861.431398,184.85131 C868.453097,290.423353 874.288339,404.95707 825.127722,448.341957 C775.967105,491.726844 826.025822,530.68294 861.431398,535.011769 C896.836973,539.340598 844.879069,613.47025 763.103669,645.834869 C708.732213,670.226877 357.033417,740.165594 146.419175,668.272855 C44.7174462,624.717907 21.7889311,486.766262 14.348443,454.673746 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "684.549294 536.95004 791.935383 611.067202 865.95219 877.811548 661.537545 845.581945",
    transform: "translate(763.744868, 707.380794) rotate(-50.000000) translate(-763.744868, -707.380794)",
    opacity: 0.5,
    fillRule: "nonzero",
    fill: "url(#linearGradient-2)",
    id: "\\u8DEF\\u5F84"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient-3)",
    id: "\\u4E91",
    d: "M808.951049,55.5626192 C808.951049,67.6414495 797.355372,77.3045137 782.708201,77.3045137 L701.538462,77.3045137 C686.891291,76.3382072 674.685315,67.1582962 674.685315,54.5963128 C674.685315,46.3827082 680.178004,39.13541 688.111888,35.2701844 C687.501589,33.8207247 686.891291,32.3712651 686.891291,30.9218055 C686.891291,22.7082009 694.825175,15.4609027 705.200254,15.4609027 C709.472346,15.4609027 713.134139,16.9103624 716.185633,18.8429752 C723.509218,7.73045137 736.935791,0 752.80356,0 C774.774317,0 792.472982,14.9777495 792.472982,33.3375715 L792.472982,35.2701844 C802.237762,38.6522568 808.951049,46.3827082 808.951049,55.5626192 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient-4)",
    id: "\\u4E91",
    d: "M199.90676,124.195804 C220.611106,124.195804 238.224949,137.427818 244.75311,155.896664 L272.84965,155.897436 C282.514633,155.897436 290.34965,163.732453 290.34965,173.397436 L290.34965,203.665501 C290.34965,213.330484 282.514633,221.165501 272.84965,221.165501 L128.828671,221.165501 C119.163688,221.165501 111.328671,213.330484 111.328671,203.665501 L111.328943,196.067284 C107.782418,190.359832 105.734266,183.62423 105.734266,176.410256 C105.734266,155.812224 122.43227,139.114219 143.030303,139.114219 C149.687735,139.114219 155.937759,140.858541 161.348274,143.915084 C169.985237,131.968524 184.03829,124.195804 199.90676,124.195804 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108.408828, 126.707504)",
    id: "\\u843D\\u53F6"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "url(#linearGradient-5)",
    id: "\\u8DEF\\u5F84-20",
    d: "M693.409627,94.2740446 C632.194154,101.505601 584.482998,91.8927403 550.27616,65.4354633 C523.214731,43.5583139 531.395959,0 557.144789,0 C582.893618,0 598.510134,21.4814086 598.510134,54.856302 C598.510134,88.2311953 581.690055,127.059619 557.144789,144.213773"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(529.621155, 138.052647) rotate(-14.000000) translate(-529.621155, -138.052647)",
    fill: "url(#linearGradient-6)",
    id: "\\u8DEF\\u5F84-18",
    d: "M555.018882,131.629751 C546.759741,120.952033 536.555831,120.952033 524.40715,131.629751 C517.982061,137.652148 513.744446,147.28334 504.223428,147.28334 C534.081583,157.693005 551.013401,152.475142 555.018882,131.629751 Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(479.730529, 128.099843) rotate(-14.000000) translate(-479.730529, -128.099843)",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "url(#linearGradient-7)",
    id: "\\u8DEF\\u5F84-19",
    d: "M498.868402,119.154546 C495.806977,125.118077 483.048395,131.081608 460.592655,137.04514"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(25.885896, 366.566076) rotate(2.000000) translate(-25.885896, -366.566076)",
    fill: "url(#linearGradient-6)",
    id: "\\u8DEF\\u5F84-18\\u5907\\u4EFD",
    d: "M51.2836234,360.143179 C43.0244824,349.465461 32.8205718,349.465461 20.6718915,360.143179 C14.246802,366.165576 10.0091875,375.796769 0.488169492,375.796769 C30.3463241,386.206433 47.2781421,380.98857 51.2836234,360.143179 Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(45.203566, 361.751431) rotate(2.000000) translate(-45.203566, -361.751431)",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "url(#linearGradient-7)",
    id: "\\u8DEF\\u5F84-19\\u5907\\u4EFD",
    d: "M64.3414398,352.806134 C61.280015,358.769666 48.5214327,364.733197 26.0656929,370.696728"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "url(#linearGradient-8)",
    id: "\\u8DEF\\u5F84-22",
    d: "M77.2570513,315.226486 C51.3834072,326.845226 29.8683109,332.654596 12.7117623,332.654596"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(362.517483, 355.804196)",
    id: "\\u76D2\\u5B50"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "21.0564343 283.431945 136.492618 260.108895 335.698955 271.430515 226.98782 308.414832",
    fill: "url(#linearGradient-9)",
    id: "\\u8DEF\\u5F84-68"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.48613 114.558869 137.48613 259.813958 266.301964 267.540578 266.06874 104.043558",
    fill: "url(#linearGradient-10)",
    id: "\\u8DEF\\u5F84-69"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.0564343 84.2257374 21.0564343 283.642557 137.48613 259.571959 137.48613 115.154328",
    fill: "url(#linearGradient-11)",
    id: "\\u8DEF\\u5F84-70"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.0564343 84.5026051 225.851943 64.4079168 335.664336 99.4198908 137.331983 115.191082",
    fill: "url(#linearGradient-12)",
    id: "\\u8DEF\\u5F84-71"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.314589 65.6465306 226.666323 309.653446 335.664336 271.479121 335.664336 97.6566792",
    fill: "url(#linearGradient-13)",
    id: "\\u8DEF\\u5F84-72"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.2950481 84.2257374 35.2288374 34.4229531 248.961371 0 229.849902 66.0268391",
    fill: "url(#linearGradient-14)",
    id: "\\u8DEF\\u5F84-73"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.70317 283.642557 0 307.601562 196.221044 343.096018 227.904936 307.601562",
    fill: "url(#linearGradient-15)",
    id: "\\u8DEF\\u5F84-74"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(305.944529, 540.797696) scale(-1, 1) translate(-305.944529, -540.797696) translate(233.776696, 377.622378)",
    id: "\\u4EBA\\u7269"
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 22.6573427,
    rx: 72.1678322,
    cy: 303.693294,
    cx: 72.1678322,
    fill: "#FEE3B1",
    id: "\\u692D\\u5706\\u5F62"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "url(#linearGradient-16)",
    id: "\\u8DEF\\u5F84-52",
    d: "M58.2027115,289.955016 L57.2133144,296.420934 C53.1839494,296.546946 48.8020725,297.731362 44.0676837,299.974182 C41.0211211,301.928815 40.8855269,302.814461 40.7874497,304.497486 C40.7220649,305.619503 49.3298134,305.619503 66.6106952,304.497486 L66.6106952,287.585309 L58.2027115,289.955016 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "url(#linearGradient-16)",
    id: "\\u8DEF\\u5F84-52\\u5907\\u4EFD-2",
    d: "M96.3805323,289.955016 L95.3911353,296.420934 C91.3617703,296.546946 86.9798933,297.731362 82.2455045,299.974182 C79.1989419,301.928815 79.0633477,302.814461 78.9652706,304.497486 C78.8998858,305.619503 87.5076343,305.619503 104.788516,304.497486 L104.788516,287.585309 L96.3805323,289.955016 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "url(#linearGradient-17)",
    id: "\\u817F",
    d: "M87.8498869,156.988768 C94.0481225,157.012932 99.0029549,157.760776 99.0029549,157.760776 C99.0029549,157.760776 97.2705968,179.97024 98.6509058,204.190398 C100.916565,243.879327 106.751508,293.532668 106.751508,293.532668 L94.4263239,293.532668 C94.4263239,293.532668 74.1698326,226.446937 74.3837623,182.674024 C67.0469704,219.547786 67.9878259,294.174142 67.9878259,294.174142 L55.0212852,292.889107 C55.0212852,292.889107 50.4481396,247.701384 49.3187957,211.379496 C48.4055609,181.952756 50.8908146,159.929403 50.8908146,159.929403 C57.2351756,159.074281 63.6606645,158.99881 70.0234333,159.704678 C70.0401566,159.706649 70.0568854,159.70863 70.0736194,159.710621 C72.88078,158.79026 76.4005875,157.843038 79.9888473,157.409078 C82.4363199,157.112764 84.9186291,156.997702 87.2463006,156.988768 L87.8498869,156.988768 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.794688, 36.241418) scale(-1, 1) translate(-81.794688, -36.241418) translate(50.775208, 0.000000)",
    id: "\\u5934"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 17.5688824,
    width: 17.5688824,
    y: 54.9139528,
    x: 24.6844683,
    fill: "url(#linearGradient-18)",
    id: "\\u77E9\\u5F62"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient-19)",
    id: "\\u692D\\u5706\\u5F62",
    d: "M41.7202378,59.896674 C58.684471,56.2589519 59.4073038,44.7433351 57.3412479,28.0232185 C52.9796846,13.8825071 38.9144288,5.22611615 25.9256198,8.68862811 C12.9368109,12.1511401 5.94304644,26.4213722 10.3046098,40.5620836 C14.6661731,54.702795 28.7314289,63.3591859 41.7202378,59.896674 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#483029",
    id: "\\u8DEF\\u5F84-66",
    d: "M24.6618577,57.7886879 C13.3651686,54.8254953 6.13923966,50.0036627 2.98407105,43.3231899 C-1.74868187,33.3024809 -0.49980635,21.3443839 4.25906157,16.1498533 C3.76672002,15.0819274 2.68451117,13.8480286 1.16002227,12.9936076 C3.01952862,12.1412743 6.18547529,11.7766608 6.95832382,12.3346959 C6.81583975,11.1730668 7.7272664,7.13460744 8.98709441,5.88667837 C8.90141844,6.76716427 9.07433565,8.0580772 9.50584604,9.75941717 C11.0230186,6.5500545 15.761373,3.52118734 23.7209093,0.672815692 C27.3205585,0.216052089 31.1566931,-0.714275735 38.3179154,0.958831431 C40.692177,1.57625417 43.742216,1.83251053 52.6194719,7.39306636 C51.5219868,7.41779906 50.8141184,7.50426636 50.4958668,7.65246827 C55.3876041,10.8064359 59.2353014,14.2489785 62.0389589,17.9800958 C61.1156642,18.4503737 60.3624463,18.6622866 59.779305,18.6158346 L61.4786116,19.4804113 L56.632956,19.4804113 L59.779305,25.5065693 C55.4788747,21.2822483 51.2986651,18.7734238 47.2386762,17.9800958 C44.6069261,17.002162 43.8364285,16.6932564 43.925778,19.4804113 C44.0151275,22.2675661 41.7613297,27.7184678 40.8902125,30.4129401 C39.6562542,33.0605525 39.5967948,34.1938892 38.0496362,36.9372005 C36.5282226,40.4225923 34.6746123,43.951868 32.4888054,47.5250277 L31.2520638,43.3231899 C28.2875698,40.9551409 26.0908344,40.9551409 24.6618577,43.3231899 C22.5183926,46.8752635 22.4481564,52.0831582 30.1639119,53.3833043 C27.4954963,54.0314771 25.6614783,55.4999383 24.6618577,57.7886879 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.114866, 63.762702)",
    id: "\\u4E0A\\u534A\\u8EAB"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient-20)",
    id: "\\u80F3\\u818A",
    d: "M56.6635137,1.38716104 C56.6635137,1.38716104 48.634852,4.9504217 44.6988921,11.5310376 C38.2132661,22.3785717 34.4932615,40.9141002 34.4932615,40.9141002 C34.4932615,40.9141002 34.1937106,46.5530467 29.9198851,54.5558534 C25.2698793,63.2612797 23.5875176,64.3503229 23.5875176,64.3503229 C23.5875176,64.3503229 16.9451499,68.8580206 15.140878,69.2475576 C12.939527,69.7235816 7.75311603,72.045928 7.75311603,72.045928 L11.2710979,82.8879273 C11.2710979,82.8879273 25.7470709,81.5473795 35.9039374,76.941433 C43.490239,73.4989081 46.457883,64.3489391 46.457883,64.3489391 L56.6635137,1.38716104 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient-21)",
    id: "\\u8863\\u670D",
    d: "M60.5973397,8.51152339 L76.0098456,0 C76.0098456,0 77.4378311,1.32043493 78.0179123,1.95007278 C79.1589518,2.76261921 80.1711798,3.55550013 80.1711798,3.55550013 C80.1711798,3.55550013 84.0660608,5.79073757 86.221528,9.43251926 C88.8048012,13.797103 88.6841155,28.6710134 88.6841155,28.6710134 C88.6841155,28.6710134 88.2455946,39.7902089 89.035913,51.4077299 C90.4009146,71.4729752 91.018376,95.2364367 91.018376,95.2364367 C91.018376,95.2364367 75.0039765,96.0986032 62.9278942,96.1840522 C50.2143953,96.2736533 38.0147265,95.4821505 38.0147265,95.4821505 L45.7542867,24.4736307 C45.7542867,24.4736307 46.9246253,12.348166 51.3865409,5.23479065 C53.3475545,2.10327265 58.338998,0.796854814 58.338998,0.796854814 L60.5973397,8.51152339 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient-22)",
    id: "\\u80F3\\u818A-2",
    d: "M80.5927568,3.83577841 C80.5927568,3.83577841 87.6844513,8.3798006 90.0947913,12.5806427 C93.7312002,18.9222089 95.3717639,47.5601002 95.3717639,47.5601002 C95.3717639,47.5601002 95.9917648,52.4203186 93.612773,56.3049646 C91.0700729,60.4563362 67.9245389,74.4945454 67.9245389,74.4945454 L48.9239536,84.9881751 L42.9399012,71.6958291 L75.3123008,47.9098533 C75.3123008,47.9098533 76.799606,46.7374368 77.0747749,45.1114829 C77.3290449,43.5927727 74.2569063,25.8726429 74.2569063,25.8726429 C74.2569063,25.8726429 73.0134215,18.7935164 74.9605026,13.629902 C76.6951116,9.03191195 80.5927568,3.83577841 80.5927568,3.83577841 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#483029",
    id: "iPad",
    d: "M2.47266005,54.9056064 L38.7183229,54.9056064 C39.1851135,54.9058816 39.6326755,55.090317 39.9625503,55.418339 C40.2924251,55.7463611 40.4775911,56.1910997 40.4773138,56.6547177 L41.532709,80.4406932 C41.532709,80.9043395 41.3479418,81.3491312 41.0180469,81.6771736 C40.6881521,82.0052153 40.2405364,82.189805 39.7737175,82.189805 L4.93524737,82.189805 C4.46842842,82.189805 4.02081274,82.0052153 3.69091791,81.6771736 C3.36102308,81.3491312 3.17588678,80.9043395 3.17625643,80.4406932 L0.713668795,56.6547177 C0.713668795,56.1910997 0.898557896,55.7463611 1.22843271,55.418339 C1.55830751,55.090317 2.00586949,54.9058816 2.47266005,54.9056064 L2.47266005,54.9056064 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEE0BC",
    id: "\\u624B",
    d: "M42.9399012,72.045928 L32.8805629,72.3621242 C32.8805629,72.3621242 31.9714606,72.3213023 31.9401122,73.9448347 C31.9540068,74.352786 32.1958579,74.7189686 32.5670794,74.894115 L35.0714645,75.8437412 C33.8415265,76.1716316 32.5831724,76.3834839 31.3131452,76.4764794 C29.6448804,76.569919 27.9726397,76.569919 26.3043749,76.4764794 C26.3043749,76.4764794 25.2141489,76.3654302 25.3639244,78.058844 C25.5276324,79.8442793 25.9908914,82.4897414 25.9908914,82.4897414 C25.9908914,82.4897414 26.2033636,84.2962798 28.4952766,84.7038065 C31.4420217,85.2293009 38.5128171,85.3365446 38.5128171,85.3365446 C40.2922955,85.3598881 42.0711137,85.2540926 43.8350708,85.0200022 C45.2840614,84.7951366 48.216874,83.7541802 48.216874,83.7541802 C48.216874,83.7541802 46.9524904,80.5953318 45.7333878,77.5592955 C44.9408186,75.6554069 44.0070925,73.8125575 42.9399012,72.045928 Z M2.9603011,72.1998748 L11.5218848,71.6930615 C11.5218848,71.6930615 12.2881779,71.5816663 12.430987,73.1173279 C12.4587911,73.4925778 12.2836933,73.8542269 11.9712111,74.0669542 L9.9126693,75.1674136 C10.9777828,75.3792301 12.0623414,75.4794121 13.148516,75.4663123 C14.5720611,75.4208384 15.9913307,75.2866931 17.3979594,75.0646671 C17.3979594,75.0646671 18.3175111,74.8716283 18.3106232,76.4885876 C18.3035786,78.1934176 18.0980726,80.7371707 18.0980726,80.7371707 C18.0037851,81.840157 17.2169009,82.7630085 16.137059,83.0370305 C13.6744717,83.7718236 7.67996987,84.4401943 7.67996987,84.4401943 C6.17308621,84.6046324 4.65522635,84.6469782 3.14142492,84.5668113 C2.58760402,84.5232219 1.84569298,84.6432653 1.32322043,84.2900528 C0.873537801,83.927278 0.522645412,83.4582799 0.302657363,82.9259813 C-0.112291735,80.8139299 -0.100451864,78.6410279 0.337488866,76.5335608 C0.542638234,75.552447 0.820895066,74.5878271 1.16996181,73.6476656 C1.41479401,72.8483785 2.12262288,72.2759797 2.9603011,72.1998748 L2.9603011,72.1998748 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(755.244755, 585.734266)",
    id: "\\u8349"
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 3.35664336,
    rx: 10.7412587,
    cy: 65.4545455,
    cx: 22.4895105,
    fill: "#BE841D",
    id: "\\u692D\\u5706\\u5F62"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient-23)",
    id: "\\u8DEF\\u5F84-42",
    d: "M11.0850616,64.1399745 C12.5477382,39.7143356 18.6753586,25.5769108 29.4679228,21.7277001 C33.7169652,21.1604083 38.4525964,20.3074441 35.1506037,25.8140938 C31.8486111,31.3207435 23.0064805,29.1777417 14.1646431,64.1254152 C13.3649201,65.6196023 12.338393,65.6244554 11.0850616,64.1399745 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient-24)",
    id: "\\u8DEF\\u5F84-41",
    d: "M10.8832896,63.8339611 C8.01184051,41.019937 5.66165622,26.6726444 3.83273669,20.7920831 C1.0893574,11.9712412 -4.75180889,-5.00472923 7.40508756,1.4177116 C19.561984,7.84015243 20.9993017,40.7841649 15.3798755,60.8332847 C13.6332399,65.9066154 12.1343779,66.9068409 10.8832896,63.8339611 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.237762, 584.055944)",
    id: "\\u77F3\\u5934"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.566434, 0.000000)",
    id: "\\u7F16\\u7EC4-4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient-25)",
    id: "\\u8DEF\\u5F84-38",
    d: "M37.5876732,83.1045271 C42.4649322,45.8402377 29.9357078,25.7651328 0,22.8792126 C40.5187676,19.0072879 67.3401946,43.6654301 67.7744935,83.1045271 C59.3740612,83.3972349 49.3117878,83.3972349 37.5876732,83.1045271 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient-26)",
    id: "\\u8DEF\\u5F84-39",
    d: "M57.2658479,83.3240579 C65.1758275,45.7193431 55.4470167,17.9446571 28.0794157,0 C63.0247371,11.0208274 88.1297864,27.5834234 96.2906905,83.3240579 C85.6260892,84.1134259 72.6178083,84.1134259 57.2658479,83.3240579 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient-27)",
    id: "\\u8DEF\\u5F84-40",
    d: "M102.491382,83.9160839 C98.9931076,48.1753148 111.822321,27.6968543 140.979021,22.4807024 C113.935141,21.7959956 83.7671642,19.9815185 62.1850531,83.9160839 C80.4750473,83.3291422 93.9104903,83.3291422 102.491382,83.9160839 Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    ry: 19.3006993,
    rx: 64.6153846,
    cy: 104.895105,
    cx: 71.3286713,
    fill: "#BE841D",
    id: "\\u692D\\u5706\\u5F62"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient-28)",
    id: "\\u692D\\u5706\\u5F62",
    d: "M52.7199758,107.410915 C80.9907756,107.410915 102.377622,108.098646 102.377622,81.5809572 C102.377622,55.063268 79.459611,33.5664336 51.1888112,33.5664336 C22.9180114,33.5664336 0,55.063268 0,81.5809572 C0,108.098646 24.449176,107.410915 52.7199758,107.410915 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient-29)",
    id: "\\u692D\\u5706\\u5F62\\u5907\\u4EFD-6",
    d: "M108.366428,107.411561 C125.977746,107.411561 139.300699,107.833578 139.300699,91.5613598 C139.300699,75.2891414 125.023905,62.0979021 107.412587,62.0979021 C89.8012695,62.0979021 75.5244755,75.2891414 75.5244755,91.5613598 C75.5244755,107.833578 90.7551098,107.411561 108.366428,107.411561 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(236.286870, 253.586002)",
    id: "\\u4E4C\\u9E26"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "url(#linearGradient-30)",
    id: "\\u8DEF\\u5F84-75",
    d: "M0,21.4688519 C3.46641927,17.8819142 8.02023457,16.9634729 13.6614459,18.7135281 C13.0629064,23.2337038 13.119818,27.3091196 13.6614459,28.4758753 C10.9466292,29.2269719 3.71410222,28.7603395 0,26.4685176 C0.533652995,25.1335413 1.41846401,24.0873752 2.65443306,23.3300192 L0,21.4688519 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE841D",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    d: "M85.7412642,0 C93.6490294,0.410576297 96.343787,1.84144773 92.0133701,5.56759467 C91.0483898,6.41426313 89.896194,7.40683137 88.7971545,8.43868212 L88.4847972,8.73447343 C88.433048,8.78391944 88.3814711,8.83343149 88.3300927,8.88299809 L88.0244108,9.18096001 L88.0244108,9.18096001 L87.7247363,9.47967825 C84.9596852,12.2695255 83.142404,15.0859927 86.8310534,15.9073004 C86.9998272,16.0272549 87.2080954,16.1481867 87.4261104,16.2763177 L87.5458155,16.3469586 C89.1325593,17.2889981 90.9437959,18.6621197 81.9057009,22.7824494 C83.9791667,23.2252294 86.0429734,23.7655363 88.0962267,24.4023844 C92.9222043,27.1165256 100.57666,31.4379921 105.210248,33.2038525 C102.239218,34.9438323 99.5061059,37.1648663 97.010911,39.8669545 L101.893605,39.8669545 C70.2785517,56.0630716 48.0069463,56.0630716 35.0787892,39.8669545 C35.0250137,39.6232831 34.9760785,39.3705018 34.9319835,39.1086107 C33.0393087,39.7638627 31.005256,40.1202918 28.8879548,40.1202918 C18.6919286,40.1202918 10.4264163,31.8547795 10.4264163,21.6587534 C10.4264163,11.4627272 18.6919286,3.19721492 28.8879548,3.19721492 C39.0839809,3.19721492 47.3494933,11.4627272 47.3494933,21.6587534 C47.3494933,22.4828319 47.2954993,23.2942994 47.1908561,24.0898113 C49.7538997,23.3820053 52.3024973,22.8065923 54.8366444,22.3635689 C60.605173,9.49374331 70.9067856,2.03876466 85.7412642,0 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 6.71328671,
    cy: 19.9804317,
    cx: 25.5313114,
    fill: "#FFFFFF",
    id: "\\u692D\\u5706\\u5F62"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.35664336,
    cy: 19.9804317,
    cx: 25.5313114,
    fill: "#483029",
    id: "\\u692D\\u5706\\u5F62"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 6.71328671,
    cy: 31.8881119,
    cx: 132.587413,
    fill: "#BE841D",
    id: "\\u692D\\u5706\\u5F62"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 6.71328671,
    cy: 31.8881119,
    cx: 166.153846,
    fill: "#BE841D",
    id: "\\u692D\\u5706\\u5F62\\u5907\\u4EFD"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 6.71328671,
    cy: 31.8881119,
    cx: 199.72028,
    fill: "#BE841D",
    id: "\\u692D\\u5706\\u5F62\\u5907\\u4EFD-2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.31f1078d67a6d8b1c4d7dab386fb9b94.svg";
export { ForwardRef as ReactComponent };